import React from "react";
import { Authorize } from "../../components/authorize";
import TextBox from "../../components/form-controls/textbox";
import DropDown from "../../components/form-controls/dropdown";
import { defaultListItem } from "../../common/const";
import * as masterService from "../../services/master/master-service";
import * as customerAnalysisService from "../../services/kyc/customer-analysis-service";
import { v4 as uuidv4 } from "uuid";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import * as Loader from "../../common/common";
import { withRouterProps } from "../../common/hocs";

class CustomerAnalysis extends Authorize {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.onClear = this.onClear.bind(this);

    this.state = {
      clientId: this.props.clientId,
      userType: this.props.clientType,
      customerAnalysis: {
        custAnalysisId: "",
        clientId: "",
        division: "CFS",
        analysisCode2: "",
        analysisCode3: "",
        analysisCode4: "",
        analysisCode5: "",
        analysisCode6: "",
        analysisCode7: "",
        analysisCode8: "",
        analysisCode9: "",
        customerStatus: "",
      },
      validationErrors: {
        customerStatusError: "",
      },

      msg: "",
      error: "",
      customerStatusData: [],
    };
  }

  onChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "customerStatus") {
      if (!value) {
        validationErrors.customerStatusError = "Please select Customer Status";
      } else {
        validationErrors.customerStatusError = "";
      }
    }

    this.setState({
      customerAnalysis: {
        ...this.state.customerAnalysis,
        [name]: value.toUpperCase(),
      },
      validationErrors: validationErrors,
    });
  }

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let {
      response,
      err,
    } = await commonDownloadPdfService.downloadCustomerAnalysis(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "CustomerAnalysis_" + clientId);
    }
  }

  async setInitialData() {
    let { response, err } = await masterService.getMastersByGroup(
      "CustomerStatus"
    );

    if (err) {
      this.setState({
        error: err,
      });
    } else {
      this.setState({
        customerStatusData: response.data,
      });
    }
  }

  async getCustomerAnalysis() {
    Loader.showLoader();
    let {
      response,
      err,
    } = await customerAnalysisService.getCustomerAnalysisData({
      data: this.state.clientId,
    });
    Loader.hideLoader();
    if (err) {
      this.setState({
        error: err,
        msg: "",
      });
    } else if (response.data && response.data.err) {
      this.setState({
        error: response.data.err,
        msg: "",
      });
    } else {
      if (response.data) {
        this.setState({
          customerAnalysis: response.data,
        });
      }
    }
  }

  componentDidMount() {
    this.setInitialData();
    this.getCustomerAnalysis();
  }

  onClear() {
    this.setState({
      customerAnalysis: {
        custAnalysisId: "",
        clientId: "",
        division: "CFS",
        analysisCode2: "",
        analysisCode3: "",
        analysisCode4: "",
        analysisCode5: "",
        analysisCode6: "",
        analysisCode7: "",
        analysisCode8: "",
        analysisCode9: "",
        customerStatus: "",
      },
      validationErrors: {},
      msg: "",
      error: "",
    });
  }

  async onSubmit(s, e) {
    if (!e) {
      e = s;
    }
    e.preventDefault();
    if (s && s === "prev") {
      if (this.state.userType === "Customer") {
        this.props.router.navigate(
          "/kycs/" +
            this.state.clientId +
            "/" +
            this.state.userType +
            "/transactionanalysis"
        );
      }
    } else {
      Loader.showLoader();
      let isSaved = false;
      let validationErrors = Object.assign({}, this.state.validationErrors);
      let validationFlag = false;
      if (!this.state.customerAnalysis.customerStatus) {
        validationErrors.customerStatusError = "Please select Customer Status";
        validationFlag = true;
      } else {
        validationErrors.customerStatusError = "";
      }

      let customerAnalysisData = Object.assign({}, this.state.customerAnalysis);

      customerAnalysisData.custAnalysisId = uuidv4();

      customerAnalysisData.clientId = this.state.clientId;
      if (validationFlag === false) {
        let {
          response,
          err,
        } = await customerAnalysisService.saveCustomerAnalysisData(
          customerAnalysisData
        );
        Loader.hideLoader();
        if (err) {
          this.setState({
            error: err,
            msg: "",
          });
        } else if (response.data && response.data.err) {
          this.setState({
            error: response.data.err,
            msg: "",
          });
        } else {
          isSaved = true;
          this.setState({
            msg: response.data.msg,
          });
        }

        if (isSaved) {
          if (s && s === "next") {
            this.props.router.navigate(
              "/kycs/" +
                this.state.clientId +
                "/" +
                this.state.userType +
                "/miscellaneouscustomer"
            );
          }
        }
      } else {
        Loader.hideLoader();
        this.setState({
          validationErrors: validationErrors,
        });
      }
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <button
                className="float-right btn btn-md btn-info"
                title="Download PDF"
                onClick={this.downloadPdf.bind(this, this.state.clientId)}
              >
                <i className="fa fa-download"></i> PDF{" "}
              </button>
            </div>
            <div className="col-md-12">
              <form onSubmit={this.onSubmit}>
                {this.state.msg ? (
                  <p className="text" style={{ color: "green" }}>
                    {this.state.msg}
                  </p>
                ) : null}
                {this.state.error ? (
                  <p className="text" style={{ color: "red" }}>
                    {this.state.error}
                  </p>
                ) : null}
                <div className="row">
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Division"
                      value={this.state.customerAnalysis.division || ""}
                      name="division"
                      onChange={this.onChange}
                      maxLength="20"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 2"
                      value={this.state.customerAnalysis.analysisCode2 || ""}
                      name="analysisCode2"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 3"
                      value={this.state.customerAnalysis.analysisCode3 || ""}
                      name="analysisCode3"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 4"
                      value={this.state.customerAnalysis.analysisCode4 || ""}
                      name="analysisCode4"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 5"
                      value={this.state.customerAnalysis.analysisCode5 || ""}
                      name="analysisCode5"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 6"
                      value={this.state.customerAnalysis.analysisCode6 || ""}
                      name="analysisCode6"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 7"
                      value={this.state.customerAnalysis.analysisCode7 || ""}
                      name="analysisCode7"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 8"
                      value={this.state.customerAnalysis.analysisCode8 || ""}
                      name="analysisCode8"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      label="Analysis Code 9"
                      value={this.state.customerAnalysis.analysisCode9 || ""}
                      name="analysisCode9"
                      onChange={this.onChange}
                      maxLength="50"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <DropDown
                      label="Customer Status"
                      required={true}
                      name="customerStatus"
                      value={this.state.customerAnalysis.customerStatus || ""}
                      onChange={this.onChange}
                      error={this.state.validationErrors.customerStatusError}
                      defaultItem={defaultListItem}
                      list={this.state.customerStatusData}
                      valProp="code"
                      textProp="name"
                    />
                  </div>
                </div>
                <div className="float-right">
                  <button
                    className="btn btn-md btn-default"
                    type="button"
                    onClick={this.onClear}
                  >
                    Clear
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-primary"
                    type="button"
                    onClick={this.onSubmit.bind(this, "prev")}
                  >
                    Previous
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-success"
                    type="submit"
                    onClick={this.onSubmit}
                  >
                    Save
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-md btn-warning"
                    type="button"
                    onClick={this.onSubmit.bind(this, "next")}
                  >
                    Save and Next
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(CustomerAnalysis);